import { RootLayoutSiteinfoFragment } from '@business/gql/graphql';
import { cn } from '@ngg/storefront-utils';
import { Dictionary } from '@ts/dictionary';
import { ContentfulImage } from '@ui/components/Contentful';
import Link from '@ui/components/Link/Link';
import Icon from '@ui/components/icon/icon';

type Props = {
  logos: RootLayoutSiteinfoFragment['siteLogoCollection'];
  icons: RootLayoutSiteinfoFragment['faviconCollection'];
  dictionary: Dictionary;
};

const uspsByKeys = [
  {
    title: 'footerUspOverXBrands',
    body: 'footerUspDiscoverXBrands',
  },
  {
    title: 'footerUspOverXProductsInStock',
    body: 'footerUspRightNowOverXProductsInStock',
  },
  {
    title: 'footerUspOriginalDesign',
    body: 'footerUspLannaIsAuthorisedSellers',
  },
  {
    title: 'footerUspSustainableInteriorDesign',
    body: 'footerUspShopInteriorDesignAndFurniture',
  },
];

const getUspsFromDictionary = (dictionary: Dictionary) => {
  return uspsByKeys.map((usp) => ({
    title: dictionary[usp.title],
    body: dictionary[usp.body],
  }));
};

export default function FooterUsps(props: Props) {
  const { icons, logos, dictionary } = props;

  const usps = getUspsFromDictionary(dictionary);

  return (
    <div
      className={cn(
        'grid grid-cols-2 gap-y-4 lg:auto-cols-fr lg:grid-flow-col lg:gap-4',
        'px-4 pb-8 pt-12 lg:pb-16 lg:pt-6',
      )}>
      <div className="grid grid-cols-4 justify-around max-lg:col-span-2 max-lg:gap-x-4 max-lg:pb-8 lg:flex">
        <ContentfulImage
          className="col-span-3 w-auto object-contain lg:h-10"
          desktopImage={logos?.items[1]?.image}
          mobileImage={logos?.items[1]?.image}
          priority
          sizes="256px"
        />
        <ContentfulImage
          className="col-span-1 w-auto object-contain lg:h-10"
          desktopImage={icons?.items[0]}
          priority
          sizes="50px"
        />
      </div>
      {usps.map(({ title, body }) => (
        <div
          className="flex flex-col gap-2 pr-2 text-sm lg:pl-4 lg:pr-0"
          key={title}>
          <div className="font-bold">{title}</div>
          <div>{body}</div>
        </div>
      ))}
      <div className="flex flex-col gap-2 lg:pl-4">
        <div className="text-sm font-bold">{dictionary.followUs}</div>
        <div className="flex items-center justify-start gap-4">
          <Link href={dictionary.footerUspSocialMediaLink}>
            <Icon name="facebook" size={24} />
          </Link>
          <Link href={dictionary.footerUspSocialMediaLink}>
            <Icon name="instagram" size={24} />
          </Link>
        </div>
      </div>
    </div>
  );
}
